import React from "react";
import { formatPrice , addServiceFees, formatePriceFn, formatPriceWithRate } from "../../../../helper/commonFunction";
import { InfoIcon } from "../../../../helper/HwIcon";
import { HotelCheckoutTabs } from "../HotelCheckoutConstants";
import { useSelector } from "react-redux";
import AedChargeNote from "../../../../component/AedChargeNote";

const HotelAmountSumary = ({
  currentTab,
  onContinue,
  details,
  pricing = {},
  setFieldValue,
  values,
  errors,
  touched,
  error,
  download,
  booking,
  bookingError,
  onlinePaymentEnable,
  acceptTerms,
  setAcceptTerms
}) => {
  const { onineServicesFees,displayPrice,agentActiveCurrency } = useSelector((state) => state.userData);
  // Booking detail (CONFIRM) shows the amount in the currency the booking was
  // MADE in (backend-stored currency + conversionRate), unaffected by the switcher.
  const bookingCurrency = details?.currency || 'AED';
  const bookingRate = Number(details?.conversionRate) || 1;
  let serviceFeeAddedAmount = pricing?.amount + (parseFloat(pricing?.amount) * parseFloat(onineServicesFees) / 100)
  return (
    <aside className="hw-passenger--fareSummary">
      {currentTab !== HotelCheckoutTabs.CONFIRM && (
        <>
          <div className="hw-passenger--fareSummary__box">
            <div className="hw-passenger--fareSummary__table">
              <div className="hw-passenger--fareSummary__thead d-flex-column hw-gapx10">
                <div className="d-flex justify-between w-100">
                  <span className="hw-black900 hw-fontBold hw-text14">Base Price</span>
                  <span className="hw-fontBold flex-shrink--null hw-text14 hw-black">
                    {formatePriceFn(agentActiveCurrency , formatPrice((pricing?.amount - pricing?.supplementAmount) || pricing?.amount), displayPrice)}
                  </span>
                </div>
                {
                  pricing?.supplementAmount !== 0 && (
                    <div className="d-flex justify-between w-100">
                      <span className="hw-black900 hw-fontBold hw-text14">Supplement Price & Fees</span>
                      <span className="hw-fontBold flex-shrink--null hw-text14 hw-black">
                        {formatePriceFn(agentActiveCurrency , formatPrice(pricing?.supplementAmount), displayPrice)}
                      </span>
                    </div>
                  )
                }
                {
                  pricing?.taxes && pricing?.taxes?.length > 0 && (
                    pricing?.taxes?.map((tax) => (
                      <div className="d-flex justify-between w-100">
                        <span className="hw-black900 hw-fontBold hw-text--capitalize hw-text14 hw-black">
                          {tax?.name}
                        </span>
                        <span className="hw-fontBold flex-shrink--null hw-text14 hw-black">
                          {tax?.sameCurrency
                            ? formatePriceFn(agentActiveCurrency, formatPrice(tax?.amount), displayPrice)
                            : `${tax?.currency_code} ${tax?.amount}`}
                        </span>
                      </div>
                    ))
                  )
                }
                  {
                    values?.paymentMethod === 'online' ?
                    <div className="d-flex justify-between w-100">
                      <span className="hw-fontBold hw-text14">Service Fees</span>
                      <span className="hw-fontBold flex-shrink--null">
                        {formatePriceFn(agentActiveCurrency , formatPrice((parseFloat(pricing?.amount) * parseFloat(onineServicesFees) / 100)), displayPrice)}
                      </span>
                    </div> : ""
                  }

              </div>
              <div className="hw-passenger--fareSummary__tfoot d-flex-column">
                <div className="d-flex justify-between w-100">
                <span className="hw-black900 hw-fontBold">Total</span>
                <span className="hw-fontBold hw-primary flex-shrink--null">
                {formatePriceFn(agentActiveCurrency , values?.paymentMethod === 'online' ? formatPrice(serviceFeeAddedAmount,true, true) : formatPrice(pricing?.amount,true, true), displayPrice)}
                </span>
                </div>
                <AedChargeNote amount={values?.paymentMethod === 'online' ? serviceFeeAddedAmount : pricing?.amount} currencyCode={agentActiveCurrency} />
              </div>
            </div>
            {pricing?.description ? (
              <div className="hw-hotel--taxNote">
                <span className="hw-hotel--taxNote__icon"><InfoIcon /></span>
                <span>{pricing?.description}</span>
              </div>
            ) : null}
            {currentTab === HotelCheckoutTabs.REVIEW && (
              <>
                {false && (
                  <div className="hw-apply--coupen mt-4">
                    <div className="hw-apply--coupenField">
                      <input
                        className="hw-form--input"
                        placeholder="Add Coupon Code"
                        onChange={(event) => {}}
                        type="text"
                      />
                      <button
                        onClick={() => {}}
                        className="hw-btn hw-btn--primary"
                      >
                        {false ? (
                          <span
                            style={{ minWidth: "2.8rem", minHeight: "2.8rem" }}
                            className="hw-main--loaderCommon"
                          />
                        ) : (
                          "Apply"
                        )}
                      </button>
                    </div>
                  </div>
                )}

                <div className="hw-term--condition mt-4">
                  <button
                    disabled={booking}
                    onClick={() => {
                      if (!acceptTerms?.value) {
                        setAcceptTerms({
                          value: false,
                          touched: true,
                        });
                      }
                      onContinue();
                    }}
                    className="hw-btn hw-btn--primary w-100"
                  >
                    {booking ? (
                      <span
                        style={{ minWidth: "2.8rem", minHeight: "2.8rem" }}
                        className="hw-main--loaderCommon"
                      />
                    ) : (
                      "Pay Now"
                    )}
                  </button>
                  <span style={{color:"red"}}>{bookingError ? bookingError : ""}</span>
                  {(error && !bookingError) && <div className="hw-p-error-cls"
                    dangerouslySetInnerHTML={{
                      __html: error,
                    }}
                  />}
                </div>
              </>
            )}
          </div>
        </>
      )}
      {currentTab === HotelCheckoutTabs.CONFIRM && (
        <>
          <div className="hw-passenger--fareSummary__box">

            <div className="hw-after--bookingWidget price-backup">
              <h4 className="h4 mb-0">Price Breakup</h4>
              <div className="hw-passenger--fareSummary__thead d-flex-column hw-gapx10">
                <div className="d-flex justify-between w-100">
                  <span className="hw-black900 hw-fontBold hw-text14">Base Price</span>
                  <span className="hw-fontBold flex-shrink--null hw-text14 hw-black">
                    {formatePriceFn(bookingCurrency, formatPriceWithRate((pricing?.amount - pricing?.supplementAmount - (pricing?.extraServicesPrice || 0)) || pricing?.amount, bookingRate), displayPrice)}
                  </span>
                </div>
                {
                  pricing?.supplementAmount !== 0 && (
                    <div className="d-flex justify-between w-100">
                      <span className="hw-black900 hw-fontBold hw-text14">Supplement Price & Fees</span>
                      <span className="hw-fontBold flex-shrink--null hw-text14 hw-black">
                        {formatePriceFn(bookingCurrency, formatPriceWithRate(pricing?.supplementAmount, bookingRate), displayPrice)}
                      </span>
                    </div>
                  )
                }
                {
                  pricing?.onlineServiceFees && pricing?.onlineServiceFees !== 0 &&
                  (<div className="d-flex justify-between w-100">
                    <span className="hw-fontBold">Service Fees</span>
                    <span className="hw-fontBold flex-shrink--null hw-text14 hw-black">
                      {formatePriceFn(bookingCurrency, formatPriceWithRate(pricing?.onlineServiceFees, bookingRate), displayPrice)}
                    </span>
                  </div>)
                }
                {
                  pricing?.extraServicesPrice && pricing?.extraServicesPrice !== 0 &&
                  (<div className="d-flex justify-between w-100">
                    <span className="hw-fontBold">Extra Service Fees</span>
                    <span className="hw-fontBold flex-shrink--null hw-text14 hw-black">
                      {formatePriceFn(bookingCurrency, formatPriceWithRate(pricing?.extraServicesPrice, bookingRate), displayPrice)}
                    </span>
                  </div>)
                }
                <div className="d-flex justify-between w-100 hw-hotel--summaryTotal">
                  <span className="hw-black900 hw-fontBold hw-text22">Total</span>
                  <span className="hw-fontBold hw-primary hw-text22 flex-shrink--null">
                    {formatePriceFn(bookingCurrency, pricing?.onlineServiceFees && pricing?.onlineServiceFees !== 0 ? formatPriceWithRate(pricing?.amount + pricing?.onlineServiceFees, bookingRate) : formatPriceWithRate(pricing?.amount, bookingRate), displayPrice)}
                  </span>
                </div>
              </div>

            </div>
          </div>
        </>
      )}
    </aside>
  );
};

export default HotelAmountSumary;
